module.exports = __webpack_public_path__ + "fonts/MASTERPLAN.0934dc1e.woff";